import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useIsMobile } from "@/hooks/use-mobile";
import { FilterSidebarSkeleton } from "@/modules/hub/features/ResourceLibrary/components/FilterSidebar/FilterSidebar/FilterSidebarSkeleton";
import MobileFilterToggleButton from "../MobileFilterToggleButton/MobileFilterToggleButton";
import { ResourceCardV2Skeleton } from "./ResourceCardV2/ResourceCardV2Skeleton";

// Initial-load skeleton for the V2 Resource Library. Mirrors the real V2 layout:
// the sticky filter sidebar, the featured carousel block, the sort/view toolbar,
// and a grid of V2 cards.
export function ResourcesLibraryV2Skeleton() {
  const isMobile = useIsMobile();

  return (
    <MainPageWrapper
      actions={<MobileFilterToggleButton onClick={() => {}} />}
      fullWidth
      sidebar={
        isMobile ? undefined : (
          <div className="w-80 shrink-0 self-start bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-700 p-2 sticky top-12 h-[calc(100vh-11rem)] overflow-y-auto [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-thumb]:rounded-sm dark:[&::-webkit-scrollbar-thumb]:bg-gray-600">
            <FilterSidebarSkeleton />
          </div>
        )
      }
      subtitle="Access and discover learning materials, documents, videos, and more"
      title="Resource Library"
    >
      <div className="flex-1 min-w-0">
        {/* Featured carousel placeholder (matches FeaturedCarouselV2 loading state) */}
        <div className="mb-6 aspect-video sm:aspect-auto sm:h-52 rounded-xl border border-gray-200 dark:border-slate-700 bg-gray-100 dark:bg-slate-800 animate-pulse" />

        {/* Sort + view toolbar */}
        <div className="flex mb-4 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl px-3 py-1.5 justify-between items-center animate-pulse">
          <div className="h-4 w-36 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="flex items-center gap-3">
            <div className="h-9 w-[180px] bg-gray-200 dark:bg-gray-700 rounded-md" />
            <div className="h-9 w-20 bg-gray-200 dark:bg-gray-700 rounded-md" />
          </div>
        </div>

        {/* Card grid */}
        <div className="grid gap-6 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <ResourceCardV2Skeleton key={i} />
          ))}
        </div>
      </div>
    </MainPageWrapper>
  );
}
